import React from 'react';
import './Theme.css';
import './UserDefinedTheme.css';

type ThemeProps = {};

const Theme: React.FC<ThemeProps> = ({ children }) => {
  return <>{children}</>;
};

export default Theme;
